import { Box, Button, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { CardItem } from '@europrocurement/flexy-components';
import { DisplayedDocument } from '../../../../providers/types';

export type DocumentFormProps = {
    selectedDocuments: Array<DisplayedDocument>;
    documents: Array<DisplayedDocument>;
    onSubmit: (documents: Array<DisplayedDocument>) => void;
    onCancel: () => void;
};

const DocumentForm: React.FunctionComponent<DocumentFormProps> = function (props) {
    const { selectedDocuments, documents, onSubmit, onCancel } = props;
    const [selectedItems, setSelectedItems] = useState<Array<number>>([]);
    const { palette } = useTheme();

    useEffect(() => {
        setSelectedItems(selectedDocuments.map((document) => document.id));
    }, [selectedDocuments]);

    const handleToggleItem = (document: DisplayedDocument) => {
        if (selectedItems.includes(document.id)) {
            setSelectedItems(selectedItems.filter((item) => item !== document.id));
        } else {
            setSelectedItems([...selectedItems, document.id]);
        }
    };

    const handleSubmit = () => {
        const result = documents.filter((document) => selectedItems.includes(document.id));

        onSubmit(result);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '0.5em' }}>
            {documents.map((document) => {
                const selected = selectedItems.includes(document.id);

                return (
                    <CardItem
                        key={document.label}
                        title={document.label}
                        additionalInfos={document?.fileName ? [document.fileName] : []}
                        icon={selected ? 'check' : 'file'}
                        color={selected ? palette.primary : undefined}
                        borderColor={selected ? palette.primary : undefined}
                        onClick={() => handleToggleItem(document)}
                    />
                );
            })}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    columnGap: '1em',
                    marginTop: '0.5em',
                }}
            >
                {onCancel && (
                    <Button
                        variant="text"
                        onClick={onCancel}
                        sx={{ color: palette.primary.dark }}
                    >
                        Annuler
                    </Button>
                )}
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={selectedItems.length === 0}
                    sx={{
                        display: 'flex',
                        columnGap: '0.5em',
                        padding: '16px 24px',
                        background: palette.primary.dark,
                    }}
                >
                    <FaOptionIcon
                        icon={['fas', 'check']}
                        sx={{ lineHeight: 0 }}
                    />
                    {selectedItems.length > 1
                        ? 'Sélectionner les documents'
                        : 'Sélectionner le document'}
                </Button>
            </Box>
        </Box>
    );
};

export default DocumentForm;
